import type { JobRunStatus } from '../types/jobs';

const LABELS: Record<JobRunStatus, string> = {
  pending: 'Pending',
  running: 'Running',
  completed: 'Completed',
  partial: 'Partial',
  failed: 'Failed',
  cancelled: 'Cancelled',
  skipped: 'Skipped',
};

interface JobStatusBadgeProps {
  status: JobRunStatus;
}

export function JobStatusBadge({ status }: JobStatusBadgeProps) {
  return (
    <span
      className={`job-status job-status--${status}`}
      aria-label={`Job status: ${LABELS[status]}`}
    >
      {LABELS[status]}
    </span>
  );
}
